import { render, staticRenderFns } from "./ai-criteria-editor.vue?vue&type=template&id=54eed01c&scoped=true&"
import script from "./ai-criteria-editor.vue?vue&type=script&lang=js&"
export * from "./ai-criteria-editor.vue?vue&type=script&lang=js&"
import style0 from "./ai-criteria-editor.vue?vue&type=style&index=0&id=54eed01c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eed01c",
  null
  
)

export default component.exports